import { extendTheme } from '@chakra-ui/react'
import { withProse } from '@nikolovlazar/chakra-ui-prose'

import { breakpoints } from './breakpoints'
import { colors } from './colors'
import { Accordion } from './components/accordion'
import { Button } from './components/button'
import { Card } from './components/card'
import { Drawer } from './components/drawer'
import { Heading } from './components/heading'
import { Link } from './components/link'
import { Modal } from './components/modal'
import { Table } from './components/table'
import { Text } from './components/text'
import { config } from './config'
import { fonts } from './fonts'

const theme = extendTheme(
  {
    components: {
      Accordion,
      Heading,
      Text,
      Button,
      Link,
      Card,
      Modal,
      Drawer,
      Table,
    },
    fonts,
    colors,
    config,
    breakpoints,
    styles: {
      global: {
        'html, body': {
          bg: '#F3F3F3',
        },
      },
    },
  },
  withProse({
    baseStyle: {
      h2: {
        fontSize: { base: '22px', md: '25px' },
        fontWeight: 'extrabold',
        letterSpacing: '-0.01em',
        lineHeight: '1.2',
        mt: '14',
        mb: '4',
        scrollMarginTop: '104px',
      },
      h3: {
        fontSize: '18px',
        fontWeight: 'bold',
        mt: '8',
        mb: '2',
        scrollMarginTop: '104px',
      },
      p: {
        color: 'grey.700',
        fontSize: '16px',
        lineHeight: '1.7',
        my: '4',
      },
      a: {
        color: '#FF394A',
        fontWeight: 'semibold',
        textDecoration: 'underline',
        textUnderlineOffset: '2px',
      },
      ul: { my: '4', pl: '5' },
      li: { color: 'grey.700', lineHeight: '1.65', my: '2', pl: '1' },
      strong: { color: 'grey.900', fontWeight: 'bold' },
      code: {
        bg: 'grey.100',
        borderRadius: '6px',
        fontSize: '0.88em',
        fontWeight: 'semibold',
        px: '1.5',
        py: '0.5',
      },
      hr: { borderColor: 'grey.200', my: '10' },
    },
  }),
)

export default theme
